"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.672 0h.454c.245 0 .442.21.442.471v15.058c0 .261-.197.471-.442.471H4.01c-.245 0-.443-.21-.443-.471V.471C3.568.21 3.766 0 4.01 0h6.72v.941H4.454v14.118h7.23V.941h-.011V0ZM8.068 13.744a.503.503 0 1 1 0-1.007.503.503 0 0 1 0 1.007Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M17.588 0h.63c.298 0 .538.24.538.537v22.926c0 .296-.24.537-.537.537H5.78a.538.538 0 0 1-.537-.537V.537c0-.296.24-.537.537-.537h10.682v1.202H6.406v21.597h11.188V1.2h-.006V0ZM12 20.56a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.45 0h.842c.396 0 .717.321.717.716v30.568a.717.717 0 0 1-.717.716H7.709a.717.717 0 0 1-.717-.716V.716c0-.395.32-.716.717-.716H21.95v1.602H8.54v28.796h14.92V1.602h-.008V0ZM16 27.414a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M35.294.092h.976c.517 0 .937.42.937.938v46.003c0 .518-.42.938-.938.938H11.732a.937.937 0 0 1-.938-.938V1.03c0-.518.42-.938.938-.938H33.42v1.875H12.67v44.129h22.663V1.967h-.038V.092ZM24 40.915a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M47.058.123h1.301c.69 0 1.25.56 1.25 1.25v61.338c0 .69-.56 1.25-1.25 1.25H15.641a1.25 1.25 0 0 1-1.25-1.25V1.373c0-.69.56-1.25 1.25-1.25h28.917v2.5H16.891v58.838H47.11V2.623h-.05v-2.5ZM32 54.553a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSmartphone = function IconSmartphone(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Smartphone' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Smartphone"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSmartphone.sizes = [16, 24, 32, 48, 64];
IconSmartphone.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSmartphone;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Smartphone.js
// module id = 1861
// module chunks = 0